var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  className: "svg-safari-fix",
  viewBox: "0 0 24 24",
  fill: "inherit",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.06 16.5597C11.79 16.5597 11.54 16.4497 11.35 16.2597L4.26996 9.10973C3.87996 8.71973 3.88996 8.07973 4.26996 7.69973C4.65996 7.30973 5.28996 7.30973 5.67996 7.69973L12.05 14.1297L18.3 7.73973C18.69 7.34973 19.32 7.33973 19.71 7.71973C20.1 8.10973 20.11 8.73973 19.73 9.12973L12.77 16.2397C12.58 16.4297 12.33 16.5397 12.06 16.5397V16.5597Z",
  fill: "inherit"
})));
export default SvgChevronDown;